import React, { useState } from "react";

//campaigns tabs
import AllCampaign from "../../CampaignsComponent/AllCampaign";
import ApprovedCampaign from "../../CampaignsComponent/ApprovedCampaign";
import PendingCampaign from "../../CampaignsComponent/PendingCampaign";
import RejectedCampaign from "../../CampaignsComponent/RejectedCampaign";

//billing tabs
import AllBilling from "../../BillingComponents/AllBilling";
import ApprovedBilling from "../../BillingComponents/ApprovedBilling";
import PendingBilling from "../../BillingComponents/PendingBilling";
import RejectedBilling from "../../BillingComponents/RejectedBilling";

//advertiser tabs
import AllAdvertisers from "../../AdvertiserComponents/AllAdvertisers";
import ApprovedAdvertisers from "../../AdvertiserComponents/ApprovedAdvertisers";
import PendingAdvertisers from "../../AdvertiserComponents/PendingAdvertisers";
import RejectedAdvertisers from "../../AdvertiserComponents/RejectedAdvertisers";

//publishers tabs

import { LayoutContainer, TabContainer, TabNavigationTab } from "./TabStyles";

const Tab = ({ campaign, billing, publisher, advertiser }) => {
  const initState = {
    all: true,
    approved: false,
    pending: false,
    rejected: false,
  };

  const [tab, setTab] = useState(initState);

  return (
    <LayoutContainer>
      <TabContainer>
        <TabNavigationTab>
          <ul>
            <li>
              <a
                href="#all-campaigns"
                className={tab.all ? "activee" : ""}
                onClick={() => setTab((tab) => ({ ...initState, all: true }))}
              >
                {campaign
                  ? "All campaigns"
                  : billing
                  ? "All billings"
                  : publisher
                  ? "All publishers"
                  : advertiser
                  ? "All advertisers"
                  : ""}
              </a>
            </li>
            <li>
              <a
                href="#approved"
                className={tab.approved ? "activee" : ""}
                onClick={() =>
                  setTab((tab) => ({
                    ...initState,
                    all: false,
                    approved: true,
                  }))
                }
              >
                Approved
              </a>
            </li>
            <li>
              <a
                href="#pending"
                className={tab.pending ? "activee" : ""}
                onClick={() =>
                  setTab((tab) => ({
                    ...initState,
                    all: false,
                    pending: true,
                  }))
                }
              >
                Pending
              </a>
            </li>
            <li>
              <a
                href="#rejected"
                className={tab.rejected ? "activee" : ""}
                onClick={() =>
                  setTab((tab) => ({
                    ...initState,
                    all: false,
                    rejected: true,
                  }))
                }
              >
                Rejected
              </a>
            </li>
          </ul>
        </TabNavigationTab>
      </TabContainer>

      <div className="tab-content">
        {tab.all && campaign ? (
          <AllCampaign />
        ) : tab.all && billing ? (
          <AllBilling />
        ) : tab.all && advertiser ? (
          <AllAdvertisers />
        ) : (
          ""
        )}

        {tab.approved && campaign ? (
          <ApprovedCampaign />
        ) : tab.approved && billing ? (
          <ApprovedBilling />
        ) : tab.approved && advertiser ? (
          <ApprovedAdvertisers />
        ) : (
          ""
        )}

        {tab.pending && campaign ? (
          <PendingCampaign />
        ) : tab.pending && billing ? (
          <PendingBilling />
        ) : tab.pending && advertiser ? (
          <PendingAdvertisers />
        ) : (
          ""
        )}

        {tab.rejected && campaign ? (
          <RejectedCampaign />
        ) : tab.rejected && billing ? (
          <RejectedBilling />
        ) : tab.rejected && advertiser ? (
          <RejectedAdvertisers />
        ) : (
          ""
        )}
      </div>
    </LayoutContainer>
  );
};

export default Tab;
